<div class="container purchase-app tw-px-6" ui-view></div>
